import {PlanExtensionCatalogProps} from "@dropDesk/domain/entities/plan_extensions/plan_extension_catalog.props";
import {CompanyExtensionEntity} from "@dropDesk/domain/entities/plan_extensions/company_extension.entity";

export class PlanExtensionCatalogEntity {
    id?: string;
    slug!: string;
    name!: string;
    description?: string | null;
    defaultPrice!: number;
    trialDays?: number | null;
    isCore!: boolean;
    isActive!: boolean;
    installed?: CompanyExtensionEntity | null;
    deleted?: boolean;
    createdAt?: string;
    updatedAt?: string;
    icon!: string;
    features!: string[];
    highlight!: string;
    highlightIcon!: string;

    constructor(props: PlanExtensionCatalogProps) {
        Object.assign(this, props);
    }

    public get billingName(){
        return `Extensão ${this.name}`;
    }
    static fromJson(json: Record<string, any>): PlanExtensionCatalogEntity {
        return new PlanExtensionCatalogEntity({
            id: json['id'] ?? null,
            slug: json['slug'] as string,
            name: json['name'] as string,
            description: json['description'] ?? null,
            defaultPrice: json['defaultPrice'] as number,
            trialDays: (json['trialDays'] as number | null) ?? null,
            isCore: (json['isCore'] as boolean) ?? false,
            isActive: (json['isActive'] as boolean) ?? false,
            deleted: (json['deleted'] as boolean | null) ?? false,
            createdAt: json['createdAt'] ?? null,
            updatedAt: json['updatedAt'] ?? null,
            installed: json['installed']
                ? CompanyExtensionEntity.fromJson(json['installed'])
                : null,
            icon: json['icon'] ?? '',
            features: (() => {
                const raw = json['features'];
                if (!raw) return [];
                if (Array.isArray(raw)) return raw as string[];
                return (raw as string).split('\n').filter((f: string) => f.trim().length > 0);
            })(),
            highlight: json['highlight'] ?? '',
            highlightIcon: json['highlightIcon'] ?? ''
        });
    }
}
